import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import AlarmIcon from '../../../../../assets/icons/alarm.svg';
import {getYcLogoFile} from '../../../../../utils/entity/file';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {user} = contexts;

  const clientName = user?.name || i18n.t('shared:client_not_found');
  const subtenantTitle =
    user?.subtenant?.title || i18n.t('shared:subtenant_not_found');

  return {
    avatar: getYcLogoFile(180),
    avatarPlaceholder: 'Your Coach',
    icon: AlarmIcon,
    iconGradient: 'success',
    title: i18n.t('shared:you_matched_with_client', {
      clientName,
      subtenantTitle: `(${subtenantTitle})`,
    }),
  };
};
